import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ConfirmationModal, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
export const GetEmailChangeConfirmationTID = (parentTestId)=>getTestIds(parentTestId);
export const EmailChangeConfirmation = (param)=>{
    let { title, description, confirmLabel, cancelLabel, biPrefix, onResolve, testId } = param;
    const { EmailChangeConfirmationTestIds } = useMemo(()=>GetEmailChangeConfirmationTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        skin: "danger",
        textAlignCenter: false,
        title: title,
        content: /*#__PURE__*/ _jsx(Typography, {
            children: description
        }),
        primaryButtonLabel: confirmLabel,
        secondaryButtonLabel: cancelLabel,
        testId: EmailChangeConfirmationTestIds.Root(),
        primaryButtonTestId: EmailChangeConfirmationTestIds.Confirm(),
        secondaryButtonTestId: EmailChangeConfirmationTestIds.Cancel(),
        bi: {
            primaryButton: {
                name: "".concat(biPrefix, "_confirm")
            },
            secondaryButton: {
                name: "".concat(biPrefix, "_cancel")
            }
        },
        onPrimaryButtonClick: ()=>onResolve(true),
        onSecondaryButtonClick: ()=>onResolve(false)
    });
};
